module.exports = __webpack_public_path__ + "media/bootstrap-icons/mask-d403add0.svg";